export default __webpack_public_path__ + "static/CRAFd-DPPA-logo-a5e59b4880aba946a100a58cf15e1057.svg";